export default "__VITE_ASSET__DyJgHFkm__"